export type PickedOrder = {
  id: string;
  customer?: { id?: string | null } | null;
  checkoutSessionId?: string | null;
};

/** Fields filled from the picked order, cleared together whenever the store changes. */
export const ORDER_DERIVED_FIELD_NAMES: readonly string[] = ['customerId', 'checkoutSessionId'];

/**
 * Emits every derived field, blanking the ones the order does not carry: leaving a previous
 * value in place would describe a different order, or a different store entirely.
 */
export function resolveOrderAutofill(order: PickedOrder, orderIdFieldName: string): Record<string, string> {
  return {
    [orderIdFieldName]: order.id,
    customerId: order.customer?.id ?? '',
    checkoutSessionId: order.checkoutSessionId ?? '',
  };
}
